export const ACTIVATE_BONUS_LOCAL_STORAGE_KEY = 'activate-bonus-bonus-id';
